<template>
  <div class="sticky-legend">
    <h4 class="center-align">Legend</h4>
    <hr />
    <table>
      <tbody>
        <tr>
          <td><data-availability-indicator :score="3"></data-availability-indicator></td>
          <td class="center-align">Lots of data available</td>
        </tr>
        <tr>
          <td><data-availability-indicator :score="2"></data-availability-indicator></td>
          <td class="center-align">Some data available</td>
        </tr>
        <tr>
          <td><data-availability-indicator :score="1"></data-availability-indicator></td>
          <td class="center-align">Little to no data available</td>
        </tr>
        <tr>
          <td><data-availability-indicator :score="0"></data-availability-indicator></td>
          <td class="center-align">Metric does not exist for this community</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import DataAvailabilityIndicator from './DataAvailabilityIndicator.vue'
export default {
  name: 'sticky-legend',
  data: function () {
    return {}
  },
  components: {
    DataAvailabilityIndicator
  }
}
</script>
<style>
  .sticky-legend {
    position: fixed;
    padding-right: .5rem;
  }
</style>



// WEBPACK FOOTER //
// StickyLegend.vue?8e36af76